// @flow
import * as React from 'react';
import * as Immutable from 'immutable';
import { themr, type ThemeType } from 'react-css-themr';
import { translate, type TFunction } from 'react-i18next';

import OverlayDialog from 'common/components/core/dialog/OverlayDialog';
import BusinessUnitChip from 'common/components/businessUnit/BusinessUnitChip';
import { BusinessUnit } from 'common/models/internal/BusinessUnits';

import theme from './BusinessUnitSelectionModal.scss';

type OwnProps = {
    showDialog: boolean,
    businessUnits: Immutable.List<BusinessUnit>,
    onBusinessUnitSelect: (id: string) => void,
    personnelName: string
};

type Props = {
    ...OwnProps,
    t: TFunction,
    theme: ThemeType
};
class BusinessUnitSelectionModal extends React.PureComponent<Props> {
    componentDidMount() {
        const { businessUnits, onBusinessUnitSelect } = this.props;
        if (businessUnits.size === 1) {
            onBusinessUnitSelect(businessUnits.get(0).businessUnitId);
        }
    }

    render() {
        const {
            showDialog,
            personnelName,
            theme,
            businessUnits,
            onBusinessUnitSelect,
            t
        } = this.props;

        return businessUnits.size > 1 ? (
            <OverlayDialog active={showDialog}>
                <div className={theme.buContainer}>
                    <div className={theme.title}>
                        {t('welcomepersonnel', { personnelName })}
                    </div>
                    <div className={theme.subtitle}>
                        {t('businessTypeSelectionText')}
                    </div>
                    <div className={theme.buChipContainer}>
                        {businessUnits.map(businessUnit => {
                            const { businessUnitId } = businessUnit;
                            return (
                                <BusinessUnitChip
                                    key={businessUnitId}
                                    onSelect={onBusinessUnitSelect}
                                    businessUnit={businessUnit}
                                />
                            );
                        })}
                    </div>
                </div>
            </OverlayDialog>
        ) : null;
    }
}

export default (themr(
    'BusinessUnitSelectionModal',
    theme
)(translate()(BusinessUnitSelectionModal)): React.AbstractComponent<OwnProps>);
